import { Outlet } from "react-router-dom";
import { ActiveHouseProvider } from "@apps/dashboard/features/houses/active-house-context";

/** Provee contexto de casa activa a onboarding y al shell del panel. */
export function ProtectedHouseOutlet(): JSX.Element {
  return (
    <ActiveHouseProvider>
      <Outlet />
    </ActiveHouseProvider>
  );
}
